
import { useState } from "react";
import { Helmet } from "react-helmet";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import EmailCampaign from "@/components/EmailCampaign";

export default function EmailCampaignPage() {
  return (
    <>
      <Helmet>
        <title>Email Campaign | HelloML</title>
        <meta 
          name="description" 
          content="Send emails to your subscribers with HelloML's email campaign tool." 
        />
      </Helmet>

      <div className="flex flex-col min-h-screen">
        <Navbar />
        
        <main className="flex-grow container max-w-4xl py-12">
          <div className="mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold mb-8">Email Campaign</h1>
            <p className="text-gray-600 mb-8">
              Use this tool to send personalized emails to your subscribers. 
              Connect with your audience and share valuable content directly to their inbox.
            </p>
            <EmailCampaign />
          </div>
        </main>
        
        <Footer />
      </div>
    </>
  );
}
